const DEFAULT_CONFIG = {
	//标题
	APP_NAME: process.env.VUE_APP_TITLE,

	//首页地址
	DASHBOARD_URL: "/dashboard",

	//版本号
	APP_VER: "1.6.9",

	//内核版本号
	CORE_VER: "1.6.9",

	//接口地址
	API_URL: "/api",
	 
	//请求超时
	TIMEOUT: 100000,
	Menu_Save_SearchName:"Menu_Save_SearchName155",
	openAI:true,
	//TokenName
	TOKEN_NAME: "token",  //admin AdminToken  //docter token
	 
	//Token前缀，注意最后有个空格，如不需要需设置空字符串
	TOKEN_PREFIX: "",
	//是那个系统   1医生  2 后台
	System_Web:2,

	//追加其他头
	HEADERS: {},

	//请求是否开启缓存
	REQUEST_CACHE: false,

	//布局 默认：default | 通栏：header | 经典：menu | 功能坞：dock
	//dock将关闭标签和面包屑栏
	LAYOUT: 'menu',

	//菜单是否折叠
	MENU_IS_COLLAPSE: false,

	//菜单是否启用手风琴效果
	MENU_UNIQUE_OPENED: false,

	//是否开启多标签
	LAYOUT_TAGS: false,
	 
	transfermenuName:"成果转化",
	transferProjectmenuName:"我的项目",
	//语言
	LANG: 'zh-cn',

	//主题颜色
	COLOR: '#00842E',
	OPenReview:"http://47.108.86.255:5001/admin/#/login?type=3",

	HOME_TITLE: '欢迎使用科技成果创新转化项目管理',
	HOME_SUMMARY: '尊敬的老师，您好！欢迎来到医院科技成果转化平台!这里，我们致力于简化科技成果转化项目的申报和管理流程，为成果转化提供便捷的操作体验。我们的平台将助您打通科研创新转化的全生命周期，实现成果评估、转化规划、资源对接和项目推介‌的智能化管理。为您的创新转化成果落地提供有力支持。让我们携手推动医疗科技创新转化的发展，惠及更多患者，共创美好未来!',
	HOME_EMTPY_TITLE: '还没有项目',
	HOME_EMTPY_SUMMARY: `暂无项目，请点击'添加项目'按钮新增项目`,
	HOME_HELP_URL: '/#/help',

	//是否加密localStorage, 为空不加密，可填写AES(模式ECB,移位Pkcs7)加密
	LS_ENCRYPTION: '',

	//localStorageAES加密秘钥，位数建议填写8的倍数
	LS_ENCRYPTION_key: '2XNN4K8LC0ELVWN4',

	Cache_Token_Name:"UserTokenName",
	Cache_UserInfo_Name:"UserInfoName",
	Cache_Menu_Name:"Pant_UserInfo_Cache_Menu",
	Cache_User_Tips:"如无法正常登录请联系医院管理员",
	Cache_User_Org:"Cache_User_Org",
	Menu_Cache_List:"Menu_Cache_List_Back",
	APP_NAME1:"四川省知识",
	APP_NAME2:"四川省医学科学院",
	
	APP_NAME3:"四川省人民医院",
	//控制台首页默认布局
	DEFAULT_GRID: {
		//默认分栏数量和宽度 例如 [24] [18,6] [8,8,8] [6,12,6]
		layout: [6, 6, 6],
		//小组件分布，com取值:views/home/components 文件名
		copmsList: [
			// ['welcome'],
			// ['about', 'ver',, 'progress'],
			['time']
		]
	}
}

//合并业务配置
import MY_CONFIG from "./myConfig"
Object.assign(DEFAULT_CONFIG, MY_CONFIG)

// 如果生产模式，就合并动态的APP_CONFIG
// public/config.js
if(process.env.NODE_ENV === 'production'){
	Object.assign(DEFAULT_CONFIG, APP_CONFIG)
}

export default DEFAULT_CONFIG
